import { Component, Input, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { cloneDeep, get, set } from 'lodash'

import { QuestionChild } from '../question.component'
import { Question } from '../../../models/question'
import { Response } from '../../../models/response'
import { AnswerStatus, Answer } from '../../../models/answer'

@Component({
  selector: 'capto-question-level-named',
  templateUrl: './question-level-named.component.html',
  styleUrls: ['./question-level-named.component.scss']
})
export class QuestionLevelNamedComponent implements QuestionChild, OnInit {
  @Input()
  formId: string
  @Input()
  question: Question
  @Input()
  response: Response
  answer: Answer
  answerSelection: Subject<object> = new Subject()

  levelAllEqual(): boolean {
    return get(this.question, 'options.level.allEqual', false)
  }

  ngOnInit(): void {
    this.answer = this.question.answer
  }

  save(id: any, value: any): void {
    // use local var because we can’t mutate state
    const answer = cloneDeep(this.answer) || {}

    set(answer, ['values', id], { id, value })

    this.answer = answer
    this.answer.status = AnswerStatus.Answered

    this.answerSelection.next(answer)
  }
}
